import { render, staticRenderFns } from "./GridItem.vue?vue&type=template&id=e24fc68a&scoped=true"
import script from "./GridItem.vue?vue&type=script&lang=js"
export * from "./GridItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24fc68a",
  null
  
)

export default component.exports